export default __webpack_public_path__ + "locales/bg/PreparationPortal.json?hash=f666e15bd04087ee0c734b68492b8b86";